import React from 'react';

import {
  TableRow,
  TableCell,
  Typography,
  Stack,
  IconButton,
  useTheme
} from '@mui/material';

import { DateTime } from 'luxon';

import { useNavigate } from 'react-router-dom';

import { ProjectMenu } from 'modules/components/layer19';
import { menuUtil } from 'modules/common';
import { MoreVert } from '@mui/icons-material';



export type ProjectTableRowProps = {
  id: string;
  location: string;
  fullAddress: string;
  dateCreated: DateTime;
  clientName: string;
  status: string;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ProjectTableRowProps) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { anchorEl, handleClick, handleClose, open } = menuUtil.useBaseMenuState();
  return (
    <TableRow
      onClick={(e) => {
        e.stopPropagation();
        navigate(`${props.id}/milestones`);
      }}
      content='list'
    >
      <TableCell
        variant='firstRounded'

      >
        <Typography
          variant='tableCellBold'
          color={theme.palette.primary.main}
        >

          {props.dateCreated.toFormat('LLL dd, yyyy')}
        </Typography>
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.clientName}
      </TableCell>
      <TableCell
        variant='body'
      >
        <Stack
          direction='column'
        >
          <Typography
            variant='body1'
          >
            {props.location}
          </Typography>
          <Typography
            variant='body2'
          >
            {props.fullAddress}
          </Typography>
        </Stack>
      </TableCell>
      <TableCell
        align='left'
        variant='body'

      >
        {props.status}
      </TableCell>

      <TableCell
        variant='lastRounded'
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            handleClick(e);
          }}
        >
          <MoreVert />
        </IconButton>
        {open && (
          <ProjectMenu.FC
            open={open}
            anchorEl={anchorEl ?? null}
            handleClick={handleClick}
            handleClose={handleClose}
            id={props.id}
          />
        )}

      </TableCell>
    </TableRow>
  );

};
